import { Component } from '@angular/core'

@Component({
  selector: 'app-ib-footer',
  templateUrl: './ib-footer.component.html',
  standalone: false,
})
export class IbFooterComponent {}
